module.exports = __webpack_public_path__ + "img/gallery-3.2066f355.jpg";